import { render, staticRenderFns } from "./ProjectGroups.vue?vue&type=template&id=ee3e6684&scoped=true"
import script from "./ProjectGroups.vue?vue&type=script&lang=js"
export * from "./ProjectGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3e6684",
  null
  
)

export default component.exports